import { Loader } from "@googlemaps/js-api-loader";

let loader: Loader | null = null;

export function getGoogleMapsLoader(options?: Partial<ConstructorParameters<typeof Loader>[0]>) {
  if (!loader) {
    loader = new Loader({
      apiKey: process.env.GOOGLE_MAPS_API_KEY || "", 
      libraries: ["places", "maps", "core", "marker"],
      language: "en",
      version: "weekly",
      ...options,
    });
  }
  return loader;
}
